import { useRef, useState, useEffect } from "react";

function useElementAtEnd() {
  const elementRef = useRef<HTMLDivElement>(null);
  const [isAtEnd, setIsAtEnd] = useState(false);

  useEffect(() => {
    function checkElementLocation() {
      if (elementRef.current) {
        const rect = elementRef.current?.getBoundingClientRect();
        const elementBottom = rect.bottom;
        const viewportHeight =
          window.innerHeight || document.documentElement.clientHeight;
        const threshold = 150;
        const atEnd = elementBottom >= viewportHeight - threshold;
        setIsAtEnd(atEnd);
      }
    }

    checkElementLocation();
    window.addEventListener("resize", checkElementLocation);

    return () => {
      window.removeEventListener("resize", checkElementLocation);
    };
  }, []);

  return { elementRef, isAtEnd };
}

export default useElementAtEnd;
